module.exports = __webpack_public_path__ + "static/media/cooking-salon-ad2.e656b7cb.jpg";